/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createPromiseRequest } from '../../../api/util/createPromiseRequest';
import { hasAccessToken } from '../../../../../utils/token';


/** ************
 * INSERT
 */

export const insertJobLine = ({ jobLine } = {}) => {
  const url = `/create-job-and-line`;

  if (!jobLine) { 
    throw new Error('Called insertJobLine without passing jobLine');
  }

  if (hasAccessToken()) {
    const post = createPromiseRequest({
      url,
      aip: 'customercreated',
      method: 'POST',
      data: {
        jobLine
      }      
    });

    // return post();
    console.log('insertJobLine - POST');
    console.log(jobLine);
    return post();
  }
  return Promise.reject(new Error('Missing token'));
};



/** ************
 * UPDATE
 */

export const updateJobLine = ({ jobLine } = {}) => {
  const url = `/job-lines/${jobLine?.id}`;

  if (!jobLine?.id) { 
    throw new Error('Called updateJobLine without a jobLine.id');
  }

  if (hasAccessToken()) {
    const put = createPromiseRequest({
      url,
      aip: 'scanline_loader',
      method: 'PUT',
      data: {
        jobLine
      }      
    });

    // return put();
    console.log('updateJobLine - PUT');
    console.log(jobLine);
    return 'done';
  }
  return Promise.reject(new Error('Missing token'));
};



/** ************
 * DELETE
 */

export const deleteJobLine = ({ jobLine } = {}) => {
  if (!jobLine?.id) { 
    throw new Error('Called deleteJobLine without a jobLine.id');
  }

  const url = `/job-lines/${jobLine?.id}`;

  if (hasAccessToken()) {
    const del = createPromiseRequest({
      url,
      aip: 'scanline_loader',
      method: 'DELETE',
      data: {
        jobLine
      }      
    });

    // return pudelt();
    console.log('deleteJobLine - DELETE');
    console.log(jobLine);
    return 'done';
  }
  return Promise.reject(new Error('Missing token'));
};
